import React from 'react';
import cn from 'classnames';

import styles from './RootContainer.less';

const RootContainer: React.FC = ({ children }) => {
  let brandingColor = window.elate.branding?.primary_color;
  const brandingIconUrl = window.elate.branding?.icon?.url;
  const isCompact = !brandingColor && !brandingIconUrl;

  if (!brandingColor) {
    brandingColor = 'white';
  }

  return (
    <div
      className={cn(styles.root, isCompact && styles.compact)}
      style={{
        background: `linear-gradient(169deg, ${brandingColor} 0%, ${brandingColor} 350px, #fff 350px)`,
      }}
    >
      <div
        className={cn(styles.card, isCompact && styles.compact)}
        style={brandingIconUrl ? { paddingTop: 80 } : undefined}
      >
        {brandingIconUrl && (
          <div className={styles.logoContainer}>
            <img alt="Practice icon" src={brandingIconUrl} style={{ height: 128 }} />
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default RootContainer;
